import { RESET_SAMPLES, SET_SAMPLES, APPEND_SAMPLES } from './types';

export const appendSamples = samples => ({ type: APPEND_SAMPLES, samples });
export const setSamples = samples => ({ type: SET_SAMPLES, samples });
export const resetSamples = () => ({ type: RESET_SAMPLES });
